var React = require('react');

function Yt (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"#FFF","fillOpacity":".5","fillRule":"evenodd","d":"M18.32 11.181c-.212.998-.994 1.73-1.939 1.842-2.231.255-4.489.255-6.74.255-2.251 0-4.508 0-6.739-.255-.944-.112-1.73-.844-1.95-1.842C.639 9.766.639 8.219.639 6.763s0-3.004.323-4.418c.222-.998.996-1.73 1.94-1.843C5.133.247 7.39.247 9.641.247c2.251 0 4.509 0 6.74.255.945.113 1.727.845 1.948 1.843.312 1.414.312 2.962.312 4.418s0 3.003-.321 4.418zm-5.123-4.968L8.054 2.956a.631.631 0 0 0-.653-.021.662.662 0 0 0-.331.57v6.515a.66.66 0 0 0 .331.57c.1.052.2.081.311.081a.573.573 0 0 0 .342-.102l5.143-3.256a.636.636 0 0 0 .302-.55.633.633 0 0 0-.302-.55z"}));
}

Yt.defaultProps = {"width":"19","height":"14","viewBox":"0 0 19 14"};

module.exports = Yt;

Yt.default = Yt;
